(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orjn-live-before-grouping-product-card-20260802"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ORJNProductCardQuickAddInitializedV5) return;
    window.ORJNProductCardQuickAddInitializedV5 = true;

    const baseUrl = window.Shopify?.routes?.root || '/';

    const drawerSelectors = [
      'cart-drawer',
      '[data-cart-drawer]',
      '.cart-drawer',
      'details[id*="CartDrawer"]',
      'details[id*="cart-drawer"]'
    ];

    const qs = (root, selectors) => {
      for (const selector of selectors) {
        const found = root.querySelector(selector);
        if (found) return found;
      }
      return null;
    };

    const getGallery = (card) => {
      if (!card) return null;
      return qs(card, [
        '.card-gallery',
        '.product-card-gallery',
        '[class*="card-gallery"]'
      ]);
    };

    const getOverlayHost = (card) => {
      if (!card) return null;

      let host = card.querySelector('.orjn-card-overlay-host');
      if (host) return host;

      host = document.createElement('div');
      host.className = 'orjn-card-overlay-host';
      card.appendChild(host);
      return host;
    };

    const syncQuickAddOffset = (card) => {
      if (!card) return;

      const content = card.querySelector('.product-card__content');
      if (!content) {
        card.style.removeProperty('--orjn-qa-row-offset');
        return;
      }

      const cardRect = card.getBoundingClientRect();
      const contentRect = content.getBoundingClientRect();
      const offset = Math.max(0, Math.round((contentRect.top - cardRect.top) * 100) / 100);

      if (offset > 0) {
        card.style.setProperty('--orjn-qa-row-offset', `${offset}px`);
      } else {
        card.style.removeProperty('--orjn-qa-row-offset');
      }
    };

    const syncAllQuickAddOffsets = (scope = document) => {
      const root = scope instanceof Element ? scope : document;
      root.querySelectorAll?.('.product-card').forEach(syncQuickAddOffset);
    };

    const placeQuickAdd = (scope = document) => {
      if (!(scope instanceof Element) && scope !== document) return;

      const quickAdds = scope.querySelectorAll
        ? scope.querySelectorAll('[data-orjn-qa]:not([data-orjn-qa-mounted])')
        : [];

      quickAdds.forEach((quickAdd) => {
        const card = quickAdd.closest('.product-card');
        if (!card) return;

        const gallery = getGallery(card);
        if (!gallery) return;

        const host = getOverlayHost(card);
        if (!host) return;

        quickAdd.setAttribute('data-orjn-qa-mounted', 'true');
        host.appendChild(quickAdd);
        syncQuickAddOffset(card);
      });

      syncAllQuickAddOffsets(scope);
    };

    const setCardActive = (quickAdd, state) => {
      const card = quickAdd?.closest('.product-card');
      if (!card) return;
      card.classList.toggle('is-qa-active', state);
    };

    const closePanel = (quickAdd) => {
      if (!quickAdd) return;

      quickAdd.classList.remove('is-open');
      setCardActive(quickAdd, false);

      const panel = quickAdd.querySelector('[data-orjn-qa-panel]');
      const trigger = quickAdd.querySelector('[data-orjn-qa-trigger]');

      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    };

    const closeAllPanels = (except = null) => {
      document.querySelectorAll('[data-orjn-qa].is-open').forEach((quickAdd) => {
        if (except && quickAdd === except) return;
        closePanel(quickAdd);
      });
    };

    const openPanel = (quickAdd) => {
      if (!quickAdd) return;

      const panel = quickAdd.querySelector('[data-orjn-qa-panel]');
      const trigger = quickAdd.querySelector('[data-orjn-qa-trigger]');
      if (!panel || !trigger) return;

      closeAllPanels(quickAdd);
      quickAdd.classList.add('is-open');
      setCardActive(quickAdd, true);
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const setLoading = (el, state) => {
      if (!el) return;
      el.classList.toggle('is-loading', state);
      if (state) {
        el.setAttribute('aria-busy', 'true');
      } else {
        el.removeAttribute('aria-busy');
      }
      el.disabled = state;
    };

    const setMessage = (quickAdd, message, type = '') => {
      const messageEl = quickAdd?.querySelector('[data-orjn-qa-message]');
      if (!messageEl) return;

      if (!message) {
        messageEl.hidden = true;
        messageEl.textContent = '';
        messageEl.removeAttribute('data-state');
        return;
      }

      messageEl.hidden = false;
      messageEl.textContent = message;
      if (type) {
        messageEl.setAttribute('data-state', type);
      } else {
        messageEl.removeAttribute('data-state');
      }
    };

    const getSectionIdsToRefresh = () => {
      const ids = new Set(['cart-icon-bubble', 'cart-live-region-text']);

      const collect = (el) => {
        if (!el) return;

        const explicitId = el.getAttribute('data-section-id');
        if (explicitId) ids.add(explicitId);

        const sectionWrapper = el.closest('[id^="shopify-section-"]');
        if (sectionWrapper) {
          ids.add(sectionWrapper.id.replace('shopify-section-', ''));
        }
      };

      drawerSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach(collect);
      });

      document.querySelectorAll('cart-items, .cart-items, [data-cart-items]').forEach(collect);
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], [id*="cart-icon-bubble"]').forEach(collect);

      return Array.from(ids).filter(Boolean);
    };

    const patchSection = (sectionId, html) => {
      if (!sectionId || !html) return;

      const target =
        document.getElementById(`shopify-section-${sectionId}`) ||
        document.querySelector(`[data-section-id="${sectionId}"]`) ||
        document.querySelector(`#${CSS.escape(sectionId)}`);

      if (!target) return;

      if (target.id === `shopify-section-${sectionId}`) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        const incoming =
          wrapper.querySelector(`#shopify-section-${sectionId}`) ||
          wrapper.firstElementChild;

        if (incoming) {
          target.innerHTML = incoming.innerHTML;
        }
        return;
      }

      target.innerHTML = html;
    };

    const patchSections = (sections) => {
      if (!sections || typeof sections !== 'object') return;
      Object.entries(sections).forEach(([sectionId, html]) => {
        patchSection(sectionId, html);
      });
    };

    const getCart = async () => {
      const response = await fetch(`${baseUrl}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Unable to read cart.');
      return response.json();
    };

    const updateCountBubbles = (count) => {
      const value = String(count);

      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const inner =
          bubble.querySelector('span') ||
          bubble.querySelector('.count') ||
          bubble;

        inner.textContent = value;
        bubble.classList.toggle('hidden', count < 1);
        bubble.classList.toggle('is-empty', count < 1);
      });

      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = value;
      });

      document.querySelectorAll('[id*="cart-icon-bubble"]').forEach((el) => {
        const inner =
          el.querySelector('.cart-count-bubble span') ||
          el.querySelector('.cart-count-bubble') ||
          el.querySelector('[data-cart-count]');

        if (inner) inner.textContent = value;
      });
    };

    const dispatchCartEvents = (cart) => {
      const detail = { cart, source: 'orjn-product-card' };

      [document, document.documentElement, window].forEach((target) => {
        target.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
        target.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail }));
        target.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail }));
        target.dispatchEvent(new CustomEvent('cart:open', { bubbles: true, detail }));
      });
    };

    const refreshThemeCartUI = async (sectionIds = []) => {
      if (!sectionIds.length) return;

      try {
        const response = await fetch(
          `${baseUrl}?sections=${encodeURIComponent(sectionIds.join(','))}`,
          {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store'
          }
        );

        if (!response.ok) return;

        const sections = await response.json();
        patchSections(sections);
      } catch (error) {}
    };

    const openCartDrawer = () => {
      drawerSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((drawer) => {
          drawer.classList.add('is-open', 'active');
          drawer.setAttribute('open', '');

          if (drawer.tagName === 'DETAILS') {
            drawer.open = true;
          }

          if (typeof drawer.show === 'function') {
            try {
              drawer.show();
            } catch (error) {}
          }
        });
      });
    };

    const addVariantAjax = async (variantId) => {
      const sectionIds = getSectionIdsToRefresh();

      const response = await fetch(`${baseUrl}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ],
          sections: sectionIds.join(','),
          sections_url: `${window.location.pathname}${window.location.search}`
        })
      });

      if (!response.ok) {
        let errorMessage = 'Unable to add to cart.';

        try {
          const errorData = await response.json();
          errorMessage =
            errorData?.description ||
            errorData?.message ||
            errorMessage;
        } catch (error) {}

        throw new Error(errorMessage);
      }

      const data = await response.json();
      return {
        data,
        sectionIds
      };
    };

    const addVariantToCart = async (variantId, quickAdd, button) => {
      if (!variantId) return;

      setLoading(button, true);
      setMessage(quickAdd, '');

      try {
        const { data, sectionIds } = await addVariantAjax(variantId);

        if (data?.sections) {
          patchSections(data.sections);
        } else {
          await refreshThemeCartUI(sectionIds);
        }

        const cart = await getCart();

        updateCountBubbles(Number(cart?.item_count || 0));
        dispatchCartEvents(cart);
        openCartDrawer();
        placeQuickAdd(document);

        setMessage(quickAdd, 'Added to cart.', 'success');
        closePanel(quickAdd);
      } catch (error) {
        setMessage(
          quickAdd,
          error?.message || 'Unable to add to cart.',
          'error'
        );
      } finally {
        setLoading(button, false);
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-orjn-qa-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const quickAdd = trigger.closest('[data-orjn-qa]');
        if (!quickAdd) return;

        const willOpen = !quickAdd.classList.contains('is-open');

        if (willOpen) {
          openPanel(quickAdd);
        } else {
          closePanel(quickAdd);
        }
        return;
      }

      const sizeButton = event.target.closest('[data-orjn-qa-size]');
      if (sizeButton) {
        event.preventDefault();
        event.stopPropagation();

        const quickAdd = sizeButton.closest('[data-orjn-qa]');
        addVariantToCart(sizeButton.dataset.variantId, quickAdd, sizeButton);
        return;
      }

      const directButton = event.target.closest('[data-orjn-qa-direct]');
      if (directButton) {
        event.preventDefault();
        event.stopPropagation();

        const quickAdd = directButton.closest('[data-orjn-qa]');
        addVariantToCart(directButton.dataset.variantId, quickAdd, directButton);
        return;
      }

      if (!event.target.closest('[data-orjn-qa]')) {
        closeAllPanels();
      }
    });

    document.addEventListener('mouseover', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;
      setCardActive(quickAdd, true);
    });

    document.addEventListener('mouseout', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;

      if (!quickAdd.contains(event.relatedTarget) && !quickAdd.classList.contains('is-open')) {
        setCardActive(quickAdd, false);
      }
    });

    document.addEventListener('focusin', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;
      setCardActive(quickAdd, true);
    });

    document.addEventListener('focusout', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;

      requestAnimationFrame(() => {
        if (!quickAdd.contains(document.activeElement) && !quickAdd.classList.contains('is-open')) {
          setCardActive(quickAdd, false);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllPanels();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          placeQuickAdd(document);
          requestAnimationFrame(() => syncAllQuickAddOffsets(document));
        },
        { once: true }
      );
    } else {
      placeQuickAdd(document);
      requestAnimationFrame(() => syncAllQuickAddOffsets(document));
    }

    window.addEventListener('load', () => syncAllQuickAddOffsets(document), { once: true });
    window.addEventListener('resize', () => syncAllQuickAddOffsets(document));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          placeQuickAdd(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ORJNProductCardQuickAddInitializedV5) return;
    window.ORJNProductCardQuickAddInitializedV5 = true;

    const baseUrl = window.Shopify?.routes?.root || '/';

    const drawerSelectors = [
      'cart-drawer',
      '[data-cart-drawer]',
      '.cart-drawer',
      'details[id*="CartDrawer"]',
      'details[id*="cart-drawer"]'
    ];

    const qs = (root, selectors) => {
      for (const selector of selectors) {
        const found = root.querySelector(selector);
        if (found) return found;
      }
      return null;
    };

    const getGallery = (card) => {
      if (!card) return null;
      return qs(card, [
        '.card-gallery',
        '.product-card-gallery',
        '[class*="card-gallery"]'
      ]);
    };

    const getOverlayHost = (card) => {
      if (!card) return null;

      let host = card.querySelector('.orjn-card-overlay-host');
      if (host) return host;

      host = document.createElement('div');
      host.className = 'orjn-card-overlay-host';
      card.appendChild(host);
      return host;
    };

    const syncQuickAddOffsets = (cards) => {
      const measurements = Array.from(new Set(cards)).filter(Boolean).map((card) => {
        const content = card.querySelector('.product-card__content');
        if (!content) return { card, offset: 0 };
        const cardRect = card.getBoundingClientRect();
        const contentRect = content.getBoundingClientRect();
        return { card, offset: Math.max(0, Math.round((contentRect.top - cardRect.top) * 100) / 100) };
      });
      measurements.forEach(({ card, offset }) => {
        if (offset > 0) card.style.setProperty('--orjn-qa-row-offset', `${offset}px`);
        else card.style.removeProperty('--orjn-qa-row-offset');
      });
    };

    const syncAllQuickAddOffsets = (scope = document) => {
      const root = scope instanceof Element ? scope : document;
      syncQuickAddOffsets(root.querySelectorAll?.('.product-card') || []);
    };

    const placeQuickAdd = (scope = document) => {
      if (!(scope instanceof Element) && scope !== document) return;

      const quickAdds = scope.querySelectorAll
        ? scope.querySelectorAll('[data-orjn-qa]:not([data-orjn-qa-mounted])')
        : [];

      const movedCards = [];
      quickAdds.forEach((quickAdd) => {
        const card = quickAdd.closest('.product-card');
        if (!card) return;

        const gallery = getGallery(card);
        if (!gallery) return;

        const host = getOverlayHost(card);
        if (!host) return;

        quickAdd.setAttribute('data-orjn-qa-mounted', 'true');
        host.appendChild(quickAdd);
        movedCards.push(card);
      });

      if (movedCards.length) requestAnimationFrame(() => syncQuickAddOffsets(movedCards));

    };

    const setCardActive = (quickAdd, state) => {
      const card = quickAdd?.closest('.product-card');
      if (!card) return;
      card.classList.toggle('is-qa-active', state);
    };

    const closePanel = (quickAdd) => {
      if (!quickAdd) return;

      quickAdd.classList.remove('is-open');
      setCardActive(quickAdd, false);

      const panel = quickAdd.querySelector('[data-orjn-qa-panel]');
      const trigger = quickAdd.querySelector('[data-orjn-qa-trigger]');

      if (panel) {
        if (panel.matches(':popover-open')) panel.hidePopover();
        panel.removeAttribute('popover');
        panel.hidden = true;
      }
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    };

    const closeAllPanels = (except = null) => {
      document.querySelectorAll('[data-orjn-qa].is-open').forEach((quickAdd) => {
        if (except && quickAdd === except) return;
        closePanel(quickAdd);
      });
    };

    // A compact top-layer popover, anchored to its product button (not a phone sheet).
    const positionCompactPreview = (quickAdd) => {
      const panel = quickAdd.querySelector('[data-orjn-qa-panel]');
      const trigger = quickAdd.querySelector('[data-orjn-qa-trigger]');
      if (!panel || !trigger) return;
      const anchor = trigger.getBoundingClientRect();
      const width = Math.min(268, window.innerWidth - 24);
      const maxHeight = Math.min(300, window.innerHeight - 140);
      const height = Math.min(panel.scrollHeight + 2, maxHeight);
      const left = Math.max(12, Math.min(anchor.right - width, window.innerWidth - width - 12));
      const below = anchor.bottom + 8;
      const above = anchor.top - height - 8;
      const top = below + height <= window.innerHeight - 12 ? below : Math.max(12, above);
      panel.style.setProperty('--qa-left', left + 'px');
      panel.style.setProperty('--qa-top', top + 'px');
    };

    const openPanel = (quickAdd) => {
      if (!quickAdd) return;

      const panel = quickAdd.querySelector('[data-orjn-qa-panel]');
      const trigger = quickAdd.querySelector('[data-orjn-qa-trigger]');
      if (!panel || !trigger) return;

      closeAllPanels(quickAdd);
      quickAdd.classList.add('is-open');
      setCardActive(quickAdd, true);
      panel.hidden = false;
      if (!panel.querySelector('[data-orjn-qa-close]')) {
        const close = document.createElement('button');
        close.type = 'button'; close.className = 'orjn-card-qa__close';
        close.dataset.orjnQaClose = ''; close.setAttribute('aria-label', 'Close size preview'); close.textContent = '×';
        close.addEventListener('click', () => { closePanel(quickAdd); trigger.focus({preventScroll:true}); });
        panel.querySelector('.orjn-card-qa__panel-head')?.appendChild(close);
      }
      if (window.matchMedia('(max-width:749px)').matches && typeof panel.showPopover === 'function') {
        panel.setAttribute('popover', 'manual'); panel.showPopover();
        positionCompactPreview(quickAdd);
      }
      trigger.setAttribute('aria-expanded', 'true');
    };

    const setLoading = (el, state) => {
      if (!el) return;
      el.classList.toggle('is-loading', state);
      if (state) {
        el.setAttribute('aria-busy', 'true');
      } else {
        el.removeAttribute('aria-busy');
      }
      el.disabled = state;
    };

    const setMessage = (quickAdd, message, type = '') => {
      const messageEl = quickAdd?.querySelector('[data-orjn-qa-message]');
      if (!messageEl) return;

      if (!message) {
        messageEl.hidden = true;
        messageEl.textContent = '';
        messageEl.removeAttribute('data-state');
        return;
      }

      messageEl.hidden = false;
      messageEl.textContent = message;
      if (type) {
        messageEl.setAttribute('data-state', type);
      } else {
        messageEl.removeAttribute('data-state');
      }
    };

    const getSectionIdsToRefresh = () => {
      const ids = new Set(['cart-icon-bubble', 'cart-live-region-text']);

      const collect = (el) => {
        if (!el) return;

        const explicitId = el.getAttribute('data-section-id');
        if (explicitId) ids.add(explicitId);

        const sectionWrapper = el.closest('[id^="shopify-section-"]');
        if (sectionWrapper) {
          ids.add(sectionWrapper.id.replace('shopify-section-', ''));
        }
      };

      drawerSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach(collect);
      });

      document.querySelectorAll('cart-items, .cart-items, [data-cart-items]').forEach(collect);
      document.querySelectorAll('.cart-count-bubble, [data-cart-count], [id*="cart-icon-bubble"]').forEach(collect);

      return Array.from(ids).filter(Boolean);
    };

    const patchSection = (sectionId, html) => {
      if (!sectionId || !html) return;

      const target =
        document.getElementById(`shopify-section-${sectionId}`) ||
        document.querySelector(`[data-section-id="${sectionId}"]`) ||
        document.querySelector(`#${CSS.escape(sectionId)}`);

      if (!target) return;

      if (target.id === `shopify-section-${sectionId}`) {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        const incoming =
          wrapper.querySelector(`#shopify-section-${sectionId}`) ||
          wrapper.firstElementChild;

        if (incoming) {
          target.innerHTML = incoming.innerHTML;
        }
        return;
      }

      target.innerHTML = html;
    };

    const patchSections = (sections) => {
      if (!sections || typeof sections !== 'object') return;
      Object.entries(sections).forEach(([sectionId, html]) => {
        patchSection(sectionId, html);
      });
    };

    const getCart = async () => {
      const response = await fetch(`${baseUrl}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Unable to read cart.');
      return response.json();
    };

    const updateCountBubbles = (count) => {
      const value = String(count);

      document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
        const inner =
          bubble.querySelector('span') ||
          bubble.querySelector('.count') ||
          bubble;

        inner.textContent = value;
        bubble.classList.toggle('hidden', count < 1);
        bubble.classList.toggle('is-empty', count < 1);
      });

      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = value;
      });

      document.querySelectorAll('[id*="cart-icon-bubble"]').forEach((el) => {
        const inner =
          el.querySelector('.cart-count-bubble span') ||
          el.querySelector('.cart-count-bubble') ||
          el.querySelector('[data-cart-count]');

        if (inner) inner.textContent = value;
      });
    };

    const dispatchCartEvents = (cart) => {
      const detail = { cart, source: 'orjn-product-card' };

      [document, document.documentElement, window].forEach((target) => {
        target.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
        target.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail }));
        target.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail }));
        target.dispatchEvent(new CustomEvent('cart:open', { bubbles: true, detail }));
      });
    };

    const refreshThemeCartUI = async (sectionIds = []) => {
      if (!sectionIds.length) return;

      try {
        const response = await fetch(
          `${baseUrl}?sections=${encodeURIComponent(sectionIds.join(','))}`,
          {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store'
          }
        );

        if (!response.ok) return;

        const sections = await response.json();
        patchSections(sections);
      } catch (error) {}
    };

    const openCartDrawer = () => {
      drawerSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((drawer) => {
          drawer.classList.add('is-open', 'active');
          drawer.setAttribute('open', '');

          if (drawer.tagName === 'DETAILS') {
            drawer.open = true;
          }

          if (typeof drawer.show === 'function') {
            try {
              drawer.show();
            } catch (error) {}
          }
        });
      });
    };

    const addVariantAjax = async (variantId) => {
      const sectionIds = getSectionIdsToRefresh();

      const response = await fetch(`${baseUrl}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify({
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ],
          sections: sectionIds.join(','),
          sections_url: `${window.location.pathname}${window.location.search}`
        })
      });

      if (!response.ok) {
        let errorMessage = 'Unable to add to cart.';

        try {
          const errorData = await response.json();
          errorMessage =
            errorData?.description ||
            errorData?.message ||
            errorMessage;
        } catch (error) {}

        throw new Error(errorMessage);
      }

      const data = await response.json();
      return {
        data,
        sectionIds
      };
    };

    const addVariantToCart = async (variantId, quickAdd, button) => {
      if (!variantId) return;

      setLoading(button, true);
      setMessage(quickAdd, '');

      try {
        const { data, sectionIds } = await addVariantAjax(variantId);

        if (data?.sections) {
          patchSections(data.sections);
        } else {
          await refreshThemeCartUI(sectionIds);
        }

        const cart = await getCart();

        updateCountBubbles(Number(cart?.item_count || 0));
        dispatchCartEvents(cart);
        openCartDrawer();
        placeQuickAdd(document);

        setMessage(quickAdd, 'Added to cart.', 'success');
        closePanel(quickAdd);
      } catch (error) {
        setMessage(
          quickAdd,
          error?.message || 'Unable to add to cart.',
          'error'
        );
      } finally {
        setLoading(button, false);
      }
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-orjn-qa-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();

        const quickAdd = trigger.closest('[data-orjn-qa]');
        if (!quickAdd) return;

        const willOpen = !quickAdd.classList.contains('is-open');

        if (willOpen) {
          openPanel(quickAdd);
        } else {
          closePanel(quickAdd);
        }
        return;
      }

      const sizeButton = event.target.closest('[data-orjn-qa-size]');
      if (sizeButton) {
        event.preventDefault();
        event.stopPropagation();

        const quickAdd = sizeButton.closest('[data-orjn-qa]');
        addVariantToCart(sizeButton.dataset.variantId, quickAdd, sizeButton);
        return;
      }

      const directButton = event.target.closest('[data-orjn-qa-direct]');
      if (directButton) {
        event.preventDefault();
        event.stopPropagation();

        const quickAdd = directButton.closest('[data-orjn-qa]');
        addVariantToCart(directButton.dataset.variantId, quickAdd, directButton);
        return;
      }

      if (!event.target.closest('[data-orjn-qa]')) {
        closeAllPanels();
      }
    });

    document.addEventListener('mouseover', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;
      setCardActive(quickAdd, true);
    });

    document.addEventListener('mouseout', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;

      if (!quickAdd.contains(event.relatedTarget) && !quickAdd.classList.contains('is-open')) {
        setCardActive(quickAdd, false);
      }
    });

    document.addEventListener('focusin', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;
      setCardActive(quickAdd, true);
    });

    document.addEventListener('focusout', (event) => {
      const quickAdd = event.target.closest('[data-orjn-qa]');
      if (!quickAdd) return;

      requestAnimationFrame(() => {
        if (!quickAdd.contains(document.activeElement) && !quickAdd.classList.contains('is-open')) {
          setCardActive(quickAdd, false);
        }
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeAllPanels();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          placeQuickAdd(document);
        },
        { once: true }
      );
    } else {
      placeQuickAdd(document);
    }

    window.addEventListener('load', () => syncAllQuickAddOffsets(document), { once: true });
    window.addEventListener('resize', () => { syncAllQuickAddOffsets(document); closeAllPanels(); });
    window.addEventListener('scroll', (event) => { if (event.target?.closest?.('[data-orjn-qa-panel]')) return; if (window.innerWidth <= 749) closeAllPanels(); }, true);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;
          placeQuickAdd(node);
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
